import React from 'react';
import {Link} from 'gatsby'

const AgendaBreadcrumb = ({SingleTitle}) => {
	// Validation des props et gestion des erreurs
	if (SingleTitle !== undefined && SingleTitle !== null && typeof SingleTitle !== 'string') {
		return (
			<div className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2" role="region" aria-label="Fil d'Ariane de navigation">
				<div className="container">
					<nav role="navigation" aria-label="Fil d'Ariane de l'agenda">
						<div role="alert" aria-live="polite">
							<p>Erreur : titre de l'événement invalide</p>
						</div>
					</nav>
				</div>
			</div>
		)
	}

	// Construction du fil d'Ariane
	const breadcrumbItems = [
		{ label: 'Accueil', to: '/', isActive: false },
		{ label: 'Sortir à Roubaix', to: '/sortir-a-roubaix/', isActive: false },
		{ label: 'Agenda', to: (SingleTitle && typeof SingleTitle === 'string' && SingleTitle.trim()) ? '/agenda/' : null, isActive: !(SingleTitle && typeof SingleTitle === 'string' && SingleTitle.trim()) }
	]

	// Ajouter le titre de l'événement si disponible
	if (SingleTitle && typeof SingleTitle === 'string' && SingleTitle.trim()) {
		breadcrumbItems.push({ 
			label: SingleTitle, 
			to: null, 
			isActive: true 
		})
	}

	return (
		<div className="d-none d-lg-block d-md-block d-sm-block order-bottom py-2" role="region" aria-label="Fil d'Ariane de navigation">
			<div className="container">
				<nav role="navigation" aria-label="Fil d'Ariane de l'agenda">
					<ol className="breadcrumb" role="list" aria-label="Navigation dans le site">
						{breadcrumbItems.map((item, index) => (
							<li 
								key={index} 
								className={`breadcrumb-item ${item.isActive ? 'active' : ''}`} 
								role="listitem"
								aria-current={item.isActive ? 'page' : undefined}
							>
								{item.to ? (
									<Link 
										className="text-dark" 
										to={item.to}
										aria-label={`Aller à ${item.label}`}
										aria-describedby={item.isActive ? undefined : `breadcrumb-${index}`}
									>
										{item.label}
									</Link>
								) : (
									<span 
										className="text-secondary"
										id={`breadcrumb-${index}`}
										aria-label={`Page actuelle : ${item.label}`}
									>
										{item.label}
									</span>
								)}
							</li>
						))}
					</ol>
					
					{/* Message de navigation pour les lecteurs d'écran */}
					<div className="visually-hidden" aria-live="polite">
						Fil d'Ariane : {breadcrumbItems.map(item => item.label).join(' > ')}
					</div>
				</nav>
			</div>
		</div>
	)
}

export default AgendaBreadcrumb;